import { ReactNode } from 'react';

import { useGuardedLocation } from 'app/router/route_guard/context';
import { Routes } from 'react-router-dom';

// Wraps Routes with the guarded location so blocked pages never mount - used to force partner selection
export const GuardedRoutes = (props: { children: ReactNode }) => {

    const { children } = props;

    const guardedLocation = useGuardedLocation();

    return (
        <Routes location={guardedLocation}>
            {children}
        </Routes>
    );

};